export {
	type BscGlobalState,
	clearGlobalState,
	getBscGlobalState,
	testing_overrideGlobalState,
	type OverrideBscGlobalStateParams,
} from './core';

export {
	initializeGlobalState,
	type InitializeBscGlobalStateParams,
} from './initialize-global-state';
